import { Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Layout from './components/layout/Layout/Layout.jsx';
import Home from './pages/Home/Home.jsx';
import Company from './pages/Company/Company.jsx';
import Solutions from './pages/Solutions/Solutions.jsx';
import Plans from './pages/Plans/Plans.jsx';
import Insights from './pages/Insights/Insights.jsx';
import Article from './pages/Article/Article.jsx';
import Contact from './pages/Contact/Contact.jsx';
import DesignSystem from './pages/DesignSystem/DesignSystem.jsx';
import Success from './pages/Success/Success.jsx';
import Privacy from './pages/Privacy/Privacy.jsx';
import Terms from './pages/Terms/Terms.jsx';
import NotFound from './pages/NotFound/NotFound.jsx';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

export default function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/company" element={<Company />} />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/plans" element={<Plans />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/insights/:slug" element={<Article />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/design-system" element={<DesignSystem />} />
          <Route path="/success" element={<Success />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </>
  );
}
